import { motion } from "framer-motion";
import { Star, BadgeCheck } from "lucide-react";

const TESTIMONIALS = [
  {
    quote:
      "Our basement flooded at 2 AM. They answered on the first ring, had pumps running by sunrise, and rebuilt the whole lower level. It looks better than before the flood.",
    name: "Sarah M.",
    location: "Appleton, WI",
    service: "Water Damage & Rebuild",
  },
  {
    quote:
      "After the kitchen fire we were overwhelmed. Redemption handled the smoke cleanup, the insurance paperwork, and the full rebuild. One company, start to finish.",
    name: "Daniel & Lisa K.",
    location: "Green Bay, WI",
    service: "Fire & Smoke Restoration",
  },
  {
    quote:
      "They found mold behind our walls and treated our family with such care. Contained, cleaned, tested, and rebuilt. You would never know anything happened.",
    name: "Robert T.",
    location: "Oshkosh, WI",
    service: "Mold Remediation",
  },
];

export default function Testimonials() {
  return (
    <section className="relative py-24 lg:py-32" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: [0.215, 0.61, 0.355, 1] }}
          className="mb-16 text-center"
        >
          <p className="font-mono-data mb-4 text-xs uppercase tracking-[0.35em] text-purple-400">
            From Our Neighbors
          </p>
          <h2 className="font-serif-display text-3xl font-medium tracking-tight text-slate-100 sm:text-4xl lg:text-5xl">
            Homes restored. <span className="italic text-purple-400">Trust earned.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={t.name}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: i * 0.12, duration: 0.8, ease: [0.215, 0.61, 0.355, 1] }}
              data-testid={`testimonial-card-${i + 1}`}
              className="flex flex-col rounded-2xl border border-white/[0.07] bg-[#111116] p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-slate-300/25"
            >
              <div className="mb-5 flex gap-1 text-amber-400" aria-label="5 star rating">
                {[...Array(5)].map((_, s) => (
                  <Star key={s} className="h-4 w-4 fill-current" />
                ))}
              </div>
              <blockquote className="font-serif-display flex-1 text-lg italic leading-relaxed text-slate-200">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-7 border-t border-white/[0.07] pt-5">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-semibold text-white">{t.name}</p>
                    <p className="font-mono-data mt-1 text-[10px] uppercase tracking-[0.2em] text-slate-500">
                      {t.location} · {t.service}
                    </p>
                  </div>
                  <span className="flex items-center gap-1.5 font-mono-data text-[9px] uppercase tracking-[0.18em] text-purple-300">
                    <BadgeCheck className="h-4 w-4" /> Verified
                  </span>
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
